// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "A widget for introducing readers to the cast of characters in a story, especially when keeping track of those at play might prove difficult.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "People gallery",
  id: "people-gallery",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/2020/people-gallery/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "PeopleGalleryConfigTool" */ "app/components/tools/PeopleGalleryConfigTool/PeopleGalleryConfigTool"),
    loading: DynamicImportLoader,
    modules: ["PeopleGalleryConfigTool"]
  })
};

export default CONFIG;
